import { render, staticRenderFns } from "./BlockResvOption.vue?vue&type=template&id=a9080602"
import script from "./BlockResvOption.vue?vue&type=script&lang=js"
export * from "./BlockResvOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports